import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

function PublicHeader({ title, subtitle, description, right_content, ctas }) {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  return (
    <Fragment>
      <section id="banner">
        <div className="content-header">
          <div className="content-header-intro">
            <h1>{title}</h1>
            {subtitle && <p>{subtitle}</p>}
            {description && <p>{description}</p>}
            {!isAuthenticated && ctas?.length > 0 && (
              <>
                <div className="closing-tf-cta-container">
                  {ctas.map((cta, index) => (
                    <Link
                      key={index}
                      to={cta.link}
                      className={`cta-button ${cta.type}`}
                    >
                      {cta.text}
                    </Link>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="content-header-right">{right_content}</div>
        </div>
      </section>
    </Fragment>
  );
}

export default PublicHeader;
